import { useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE } from "../utils/api";

export default function ForgotPassword() {
  const [email,     setEmail]     = useState("");
  const [loading,   setLoading]   = useState(false);
  const [sent,      setSent]      = useState(false);
  const [error,     setError]     = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const res = await fetch(`${API_BASE}/api/email-auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (res.ok) setSent(true);
      else { const d = await res.json(); setError(d.detail || "Something went wrong"); }
    } catch { setError("Connection error. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-luxury-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md">

        {/* Logo */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="w-10 h-10 glass-gold rounded-xl flex items-center justify-center">
            <svg className="w-5 h-5 text-luxury-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <span className="text-xl font-bold text-luxury-text">Tax<span className="text-luxury-gold">Vault</span></span>
        </div>

        <div className="glass-strong rounded-2xl p-8 border border-white/[0.07]">
          {sent ? (
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-5 glass-gold rounded-2xl flex items-center justify-center text-3xl">📧</div>
              <h2 className="text-2xl font-bold text-luxury-text mb-2">Check Your Email</h2>
              <p className="text-luxury-secondary text-sm leading-relaxed mb-6">
                If <strong className="text-luxury-text">{email}</strong> is registered, a password reset link has been sent to <strong className="text-luxury-gold">info@taxvault.live</strong>.<br/>Check your inbox and spam folder.
              </p>
              <div className="p-4 glass rounded-xl mb-6 text-left">
                <p className="text-luxury-muted text-xs">📬 Reset email sent from: <span className="text-luxury-gold">no-reply@taxvault.live</span></p>
                <p className="text-luxury-muted text-xs mt-1">⏰ Link expires in 1 hour</p>
              </div>
              <Link to="/login" className="block w-full text-center py-3 bg-luxury-gold hover:bg-luxury-gold-dim text-white font-bold rounded-xl transition-all text-sm">
                Back to Login
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-bold text-luxury-text mb-1">Forgot Password?</h2>
              <p className="text-luxury-secondary text-sm mb-6">Enter your email and we'll send a reset link.</p>

              {error && (
                <div className="glass border border-red-500/30 text-red-400 px-4 py-3 rounded-xl mb-5 text-sm">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-luxury-secondary mb-1.5">Email Address</label>
                  <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.co.za"
                    className="w-full px-4 py-3 rounded-xl border border-luxury-border bg-luxury-elevated text-luxury-text placeholder-luxury-muted focus:outline-none focus:border-luxury-gold/50 focus:ring-2 focus:ring-luxury-gold/10 text-sm transition-all" />
                </div>
                <button type="submit" disabled={loading || !email}
                  className={`w-full py-3.5 rounded-xl font-bold text-sm transition-all active:scale-95
                    ${loading || !email ? "opacity-50 cursor-not-allowed glass text-luxury-muted" : "bg-luxury-gold hover:bg-luxury-gold-dim text-white shadow-md hover:shadow-luxury-gold/25"}`}>
                  {loading ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                      </svg> Sending...
                    </span>
                  ) : "Send Reset Link →"}
                </button>
              </form>

              <p className="text-center text-luxury-muted text-sm mt-5">
                Remember your password?{" "}
                <Link to="/login" className="text-luxury-gold hover:underline font-semibold">Sign In</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
